import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchBranches } from "../../utils/Apis";
import { motion } from "framer-motion";

function ContactUs() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const MotionTypography = motion(Typography);
  const branches = useSelector((state) => state.data.branches?.branches);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!branches) dispatch(fetchBranches());
  }, [branches, dispatch]);
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 4, md: 6 },
        py: { xs: 4, md: 6 },
        backgroundColor: "#f5f5f5",
      }}
    >
      {/* Heading */}
      <MotionTypography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "#333",
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
          textAlign: "center",
          mb: 3,
        }}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        Get in Touch
      </MotionTypography>

      {/* Branch Info Section */}
      <Grid
        container
        spacing={4}
        sx={{ mb: 5, justifyContent: "space-around" }}
      >
        {branches?.map((branch) => (
          <Grid item xs={12} md={6} key={branch._id}>
            <Box
              sx={{
                backgroundColor: "white",
                p: 3,
                borderRadius: 3,
                boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                height: "100%",
                width: { xs: "18rem", sm: "20vw", md: "40vw" },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                {branch.name}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <FaMapMarkerAlt color="#1976d2" style={{ marginRight: 10 }} />
                <Typography>
                  {branch.location.address} {", "} {branch.location.city}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <FaPhone color="#1976d2" style={{ marginRight: 10 }} />
                <Typography>{branch.contact.phone}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <FaEnvelope color="#1976d2" style={{ marginRight: 10 }} />
                <Typography>{branch.contact.email}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Contact Form */}
      <Box
        sx={{
          backgroundColor: "white",
          p: { xs: 3, md: 5 },
          borderRadius: 3,
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            mb: 3,
            color: "#222",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          Send Us a Message
        </Typography>

        <Grid container spacing={2} sx={{ display: "flex" }}>
          <Grid item xs={12} md={4} size={{ xs: 12, md: 3 }}>
            <TextField
              fullWidth
              label="Your Name"
              variant="outlined"
              required
            />
          </Grid>
          <Grid item xs={12} md={4} size={{ xs: 12, md: 3 }}>
            <TextField
              fullWidth
              label="Your Email"
              variant="outlined"
              type="email"
              required
            />
          </Grid>
          <Grid item xs={12} md={4} size={{ xs: 12, md: 3 }}>
            <TextField
              fullWidth
              label="Mobile No"
              variant="outlined"
              type="tel"
              inputProps={{ maxLength: 10 }}
              required
            />
          </Grid>
          <Grid item xs={12} md={12} size={{ xs: 12, md: 3 }}>
            <TextField fullWidth label="Subject" variant="outlined" required />
          </Grid>
          <Grid item xs={12} md={12} size={{ xs: 12, md: 12 }}>
            <TextField
              fullWidth
              multiline
              rows={5}
              label="Your Message"
              variant="outlined"
              required
            />
          </Grid>
        </Grid>

        <Box sx={{ textAlign: isMobile ? "center" : "left", mt: 4 }}>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#333",
              // fontWeight: "bold",
              "&:hover": { bgcolor: "grey.800" },
              borderRadius: "22px",
            }}
          >
            Send Message
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ContactUs;
